import React, {PropTypes} from 'react';
import './OrderSummary.less';

class OrderSummary extends React.Component {
  renderCartItems(cartItems) {
    return (
      <ul className="cart-items">
        {cartItems.map(item => (
          <li key={item.dish.id} className="cart-item">
          <span className="cart-item-name">
            {item.dish.name}
            {item.count > 1 && <strong className="cart-item-count">&nbsp;x{item.count}</strong>}
          </span>
          <span className="cart-item-price">{item.dish.price * item.count} zł</span>
          </li>
        ))}
        <li className="cart-item cart-item-delivery">
          Dostawa
          <span className="cart-item-price">0 zł</span>
        </li>
      </ul>
    );
  }

  renderAddress(address) {
    return (
      <section className="address">
        <div>{address.streetAddress}</div>
        <div>{address.phone}</div>
      </section>
    );
  }

  render () {
    const {address, cartItems} = this.props;
    const {renderCartItems, renderAddress} = this;

    return (
      <section className="order-summary">
        <h1>Zamówenie</h1>
        {renderCartItems(cartItems)}
        {renderAddress(address)}
      </section>
    );
  }
}

OrderSummary.propTypes = {
  address: PropTypes.object,
  cartItems: PropTypes.array
};

export default OrderSummary;



// WEBPACK FOOTER //
// ./src/components/OrderModal/OrderSummary/OrderSummary.js